<template>
	<footer :class="$i18n.locale">
		<div class="container">
			<div class="left">
				<div>
					<img
					src="~@/assets/img/logo-white.svg"
					alt="FoodBank logo white"
					/>
				</div>

				<div>
					<Search class="footer" />
				</div>
			</div>
			<div class="center">
				<ul class="footer-contact">
					<li>
						<h3 v-html="$t('Foot.contact.address.title')"></h3>
						<p v-html="$t('Foot.contact.address.description1')"></p>
						<p v-html="$t('Foot.contact.address.description2')"></p>
					</li>
					<li>
						<p class="margin-none" v-html="$t('Foot.contact.schedule.days')">y</p>
						<p v-html="$t('Foot.contact.schedule.time')"></p>
						<p v-html="$t('Foot.contact.schedule.closed')"></p>
					</li>
					<li class="contact-phone">
						<p class="margin-none">
							<span v-html="$t('Foot.contact.phone.pretitle')"></span> <a v-html="$t('Foot.contact.phone.title')" :href="$t('Foot.contact.phone.url')"></a>
						</p>
						<p v-html="$t('Foot.contact.fax.title')"></p>
					</li>
				</ul>

				<ul v-for="(footerlink, index) in menus" :key="index" :class="index">
					<template v-for="(link, linkIndex) in footerlink ">
						<template v-if="link.url == null">
							<li v-html="link.title" :key="linkIndex"></li>
						</template>

						<Link
						v-else
						:title="link.title"
						:url="link.url"
						:target="link.target"
						:image="link.image"
						:key="linkIndex"
						/>
					</template>
				</ul>
			</div>
			<div class="right">
				<a :href="$t('Foot.iconlink')" target="_blank">
					<img
					src="~@/assets/img/imagine-canada-logo.svg"
					alt="FoodBank logo white"
					/>
				</a>

				<ul class="bottom">
					<Link
					v-for="(social, index) in socials"
					:key="index"
					:title="social.title"
					:url="social.url"
					:target="social.target"
					:svg="social.image"
					/>
				</ul>
			</div>
		</div>
	</footer>
</template>
<script>
	import Search from '../partials/Search.vue'
	import Link from '../partials/Link.vue'
	export default {
		name: 'Foot',
		components: { Search, Link },
		computed: {
			menus() {
				return this.$t('Foot.links')
			},
			socials() {
				return this.$t('Foot.social')
			},
		},
	}
</script>

<style lang="scss">

</style>
